import { mobileMenu } from "./mobileMenu";

export const menuAnchor = (menuItem: string) => {
  return mobileMenu() ? `${menuItem}Mobile` : menuItem;
};
